export default __webpack_public_path__ + "static/logo-background-6208efaf8a482d3cfe22353f1cc81c2f.svg";